export const SET_IS_ALL_GOAL = "SET_IS_ALL_GOAL";

// functions that mutate store
export const setIsAllGoal = (value) => {
  return {
    type: SET_IS_ALL_GOAL,
    payload: value,
  };
};
